
import { Component, Vue, Watch } from 'vue-property-decorator'
import { OrderDtlResApi } from "@/api/order";
import math from "@/core/math";

@Component
export default class SelectGoods extends Vue {
  title = '选择退货商品'
  showDialog = false
  checkedAll = false
  a = 1
  goodsList: OrderDtlResApi[] = []
  amountMoney = 1000.23
  selectData: OrderDtlResApi[] = []

  @Watch('goodsList', { deep: true })
  changeGoodsList (val: OrderDtlResApi[]) {
    this.selectData = []
    if (val && val.length > 0) {
      this.amountMoney = 0
      val.forEach((item) => {
        if (item.isChecked) {
          this.amountMoney = Number(math.mathAdd(this.amountMoney, math.mathMultiply(item.salePrice, item.saleAmount || 0)))
          this.selectData.push(item)
        }
      })
      this.checkedAll = val.every(i => i.isChecked)
    }
  }

  show (data: OrderDtlResApi[], selectList: OrderDtlResApi[], title?: string) {
    this.showDialog = true
    title && (this.title = title)
    this.selectData = selectList
    if (selectList && selectList.length > 0) {
      const arr = data.map((item, index) => {
        selectList.forEach((select) => {
          if (select.orderDtlId === item.orderDtlId) {
            item = select
          }
        })
        return item
      })
      this.goodsList = JSON.parse(JSON.stringify(arr))
    } else {
      this.goodsList = JSON.parse(JSON.stringify(data.map((item) => {
        item.isChecked = false
        item.saleAmount = item.returnSaleAmount
        return item
      })))
    }

  }

  cancel () {
    this.showDialog = false
  }

  onItemChange () {
    this.checkedAll = this.goodsList.every(i => i.isChecked)
  }

  selectAll () {
    this.goodsList = JSON.parse(JSON.stringify(this.goodsList.map((item) => {
      item.isChecked = this.checkedAll
      return item
    })))
  }

  selectGoods () {
    this.$emit('getSelectGoods', this.selectData)
    this.showDialog = false
  }
}
